import { render, staticRenderFns } from "./CrewDataManagement.vue?vue&type=template&id=89e46ce8"
import script from "./CrewDataManagement.vue?vue&type=script&lang=js"
export * from "./CrewDataManagement.vue?vue&type=script&lang=js"
import style0 from "./CrewDataManagement.vue?vue&type=style&index=0&id=89e46ce8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports